import ManualNav from './ManualNav';

export default ManualNav;
